import { robotoRegular, scarpaGray800 } from '@habitech/shared';
import styled from 'styled-components';

export const Wrapper = styled.div`
    .text {
        font-family: ${robotoRegular};
        font-size: 18px;
        color: ${scarpaGray800};
    }
`;

export const Form = styled.div`
    margin: 48px 0;
    max-width: 450px;
    .wrapper-buttons {
        margin: 24px 0;
        display: flex;
        gap: 32px;
    }
`;

export const WrapperButton = styled.div`
    max-width: 100%;
    justify-content: center;
    display: flex;
`;

export const TextModal = styled.div`
    font-size: 22px;
    text-align: center;
    margin: 24px;
`;